import { clsx } from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from './styles.module.scss'

interface Props {
  bgColor: string
  title: string
  icon: AllIcons
}

export const TagTicket = ({ bgColor, title, icon }: Props) => {
  return (
    <div
      className={clsx('semi-bold-11', s.container)}
      style={{ background: bgColor }}
    >
      <AppIcon
        id={icon}
        width={10}
        height={10}
      />
      <span className={s.title}>{title}</span>
    </div>
  )
}
